import ItemPersonDTO from "../../DTO/ItemPersonDTO";
import mainservice from "../../../services/MainService";
import { Avatar } from "@mui/material";



export function PersonBubble(props: {
  item: ItemPersonDTO;
  onClick?: (id: number, item: ItemPersonDTO) => void;
}) {
  const item = props.item;
  return <Avatar
    sx={{ bgcolor: item.nameToColor() }}
      onClick={() => {
        if (props.onClick) {
          props.onClick(item.id, item);
          return;
        }
        mainservice.navTo([['view', 'spPersonEdit'], ['id', item.id]]);
      }
    }
  >{item.getInitials()}</Avatar>
  return <div
    title={`${item.getDisplayName()}`}
    className={`personBubble`}
    onClick={() => {
      if (props.onClick) {
        props.onClick(item.id, item);
        return;
      }
      mainservice.navTo([['view', 'spPersonEdit'], ['id', item.id]]);
    }}
    style={{ backgroundColor: item.nameToColor() }}
  ><span>{item.getInitials()}</span></div>;
}
